import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Layout, Modal, Button, Row, Col, Popover, Divider, Avatar, Space } from 'antd';
import { MenuFoldOutlined, UserOutlined, LogoutOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { isMobile } from 'react-device-detect';
import AppDrawer from '@/layouts/AppDrawer';
import logo from '@/assets/img/logo-white-text.png';
import { logout } from '@/redux/actions/authActions';
import NotificationPopover from '@/components/NotificationPopover';
import { updateLastSeen } from '@/redux/actions/userActions';

const { Header } = Layout;
const { confirm } = Modal;

class AppHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }

    componentDidMount() {
        const { authUser } = this.props;
        //console.log("authUser", authUser);

        // Chỉ chạy khi user đã login
        if (authUser && authUser.id) {
            this.startLastSeenInterval();
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
        }
    }

    componentDidUpdate(prevProps) {
        // Khi user login thành công (trước đó null → bây giờ có user)
        if (!prevProps.authUser && this.props.authUser) {
            this.startLastSeenInterval();
        }

        // Khi user logout
        if (prevProps.authUser && !this.props.authUser) {
            this.clearLastSeenInterval();
        }
    }

    componentWillUnmount() {
        this.clearLastSeenInterval();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    /** =======================
     *  LAST SEEN INTERVAL
     * ======================= */
    startLastSeenInterval = () => {
        // Ping online 1m30s
        this.props.updateLastSeen();

        this.lastSeenInterval = setInterval(() => {
            if (!document.hidden) {
                this.props.updateLastSeen();
            }
        }, 90000);
    };

    clearLastSeenInterval = () => {
        if (this.lastSeenInterval) clearInterval(this.lastSeenInterval);
    };

    handleVisibilityChange = () => {
        if (!document.hidden) {
            this.props.updateLastSeen();
        }
    };

    toggleDrawer = (visible) => {
        this.setState({ visible });
    };

    onLogout = () => {
        confirm({
            title: 'Xác nhận đăng xuất',
            icon: <ExclamationCircleOutlined />,
            content: 'Bạn chắc chắn muốn đăng xuất chứ?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => {
                this.props.logout().then(() => (window.location.href = '/login'));
            }
        });
    };

    render() {
        const { visible } = this.state;
        const { authUser } = this.props;

        return (
            <Header id="custom-header" style={!isMobile ? { paddingRight: '30px' } : null}>
                <Row justify="space-between" align="middle">
                    <Col>
                        <div className="logo">
                            <Link to="/">
                                <img src={logo} alt="Logo" />
                            </Link>
                        </div>
                    </Col>

                    <Col>
                        {isMobile ? (
                            <>
                                <NotificationPopover />
                                <Divider type="vertical" style={{ margin: '0 10px' }} />
                                <Button
                                    type="link"
                                    icon={<MenuFoldOutlined className="header-icons" />}
                                    onClick={() => this.toggleDrawer(true)}
                                />
                            </>
                        ) : (
                            <Space size="small" align="center">
                                {/* Popover Thông báo */}
                                <NotificationPopover />
                                <Divider type="vertical" style={{ margin: '0 5px' }} />
                                {/* Popover Tài khoản */}
                                <Popover
                                    className="header-actions"
                                    placement="bottomRight"
                                    content={
                                        <div>
                                            <Link to="/profile">
                                                <Button type="link" className="p-0 align-items-center">
                                                    <InfoCircleOutlined /> Thông tin tài khoản
                                                </Button>
                                            </Link>
                                            <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                            <Button
                                                type="link"
                                                className="p-0 align-items-center"
                                                onClick={() => this.onLogout()}
                                            >
                                                <LogoutOutlined /> Đăng xuất
                                            </Button>
                                        </div>
                                    }
                                    title={null}
                                >
                                    <Avatar
                                        style={{ backgroundColor: '#1b4752', verticalAlign: 'middle' }}
                                        size={35}
                                    >
                                        <UserOutlined className="header-icons" />
                                    </Avatar>
                                    &nbsp;
                                    <span className="text-white">
                                        {authUser ? authUser.full_name : null}
                                    </span>
                                </Popover>
                            </Space>
                        )}
                    </Col>
                </Row >

                <AppDrawer visible={visible} onClose={() => this.toggleDrawer(false)} />
            </Header >
        );
    }
}

function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    };
}

function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch(logout()),
        updateLastSeen: () => dispatch(updateLastSeen())
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppHeader));
